import { gql } from "@apollo/client";


//To get the user profile details
export const GET_CURRENT_USER = gql`
query getCurrentUser($classCode: String) {
  getCurrentUser {
    nodes {
      uId
      uEmailId
      uRole
      uFullName
      uUserName
      uUserPassword
      uPhoneNumber
      uCognitoId
      chimeUserArn
      schoolAdminsByUId {
        nodes {
          saId
          saName
          saNotificationEnabled
          saWebsite
          saEmailId
          adminType
          saDescription
          saAvatarUrl
          facilitatorsBySaId{
            nodes{
              facId
            }
          }
        }
      }
      teachersByUId {
        nodes {
          tName
          tId
          tAvatarUrl
          teacherSubjectsByTId(condition: {deletedAt: null}) {
            nodes {
              subjectBySjId {
                sjName
                sjOriginalName
                sjId
              }
            }
          }
        }
      }
      studentsByUId {
        nodes {
          sId
          sAvatarUrl
          studentClassroomsBySId(filter: {isActive: {equalTo: true} classroomByCId: { cCode: { equalTo: $classCode } }}) {
            nodes {
              cId
              classroomByCId {
                cName
                cOriginalName
              }
            }
          }
        }
      }
      facilitatorsByUId {
        nodes {
          facId
          facAvatarUrl
        }
      }
    }
  }
  schoolAdmin: allSchoolAdmins {
    nodes {
      saName
      saEmailId
      saDescription
      saAvatarUrl
      saWebsite
      adminType
    }
  }
  studentProfile {
    registrationId
    profileCompletedAt
  }
}
`;


// To list the teachers
export const GET_TEACHERS_LIST = gql`
query getAllTeachers($limit: Int, $offset: Int, $orderBy: [TeachersOrderBy!], $searchInput: String! = "%") {
  allTeachers(
    first: $limit
    offset: $offset
    orderBy: $orderBy
    condition: {deletedAt: null}
    filter: {tName: {likeInsensitive: $searchInput}}
  ) {
    nodes {
      teacherId: tId
      teacherName: tName
      avatarUrl: tAvatarUrl
      mainSubject: teacherSubjectsByTId(condition: {isPrimary: true, deletedAt: null}) {
        nodes {
          tsId
          subjectBySjId {
            subjectId: sjId
            subjectName: sjName
            subjectOriginalName: sjOriginalName
          }
          isPrimary
        }
      }
    }
    totalCount
  }
}
`

// To list the classrooms

export const GET_CLASSROOM_LIST = gql`
query getAllClassrooms($limit: Int, $offset: Int, $orderBy: [ClassroomsOrderBy!], $searchInput: String! = "%") {
  allClassrooms(
    first: $limit
    offset: $offset
    orderBy: $orderBy
    condition: {deletedAt: null}
    filter: {cOriginalName: {likeInsensitive: $searchInput}}
  ) {
    nodes {
      cCode
      cId
      cName
      cOriginalName
      cStudentsCount
      classroomSubjectsByCId {
        nodes {
          subjectBySjId {
            sjName
            sjOriginalName
          }
        }
      }
    }
    totalCount
  }
}
`;


//To edit a teacher

export const EDIT_TEACHER = gql`
mutation updateTeachersByTId($input: UpdateTeacherInp!) {
  updateTeachersByTId(input: $input) {
    message
  }
}
`

// To get the particular teacher

export const GET_TEACHER_BY_ID = gql`
query getTeacherDetails($tId: UUID!) {
  teacherByTId(tId: $tId) {
    tName
    tId
    tIsActive
    tAvatarUrl
    deletedAt
    mainSubject:teacherSubjectsByTId(condition: {deletedAt: null, isPrimary: true}) {
      nodes {
        sjId
        tsId
        isPrimary
        deletedAt
        subjectBySjId {
          sjName
          sjOriginalName
        }
      }
    }
    NonPrimarySubjects:teacherSubjectsByTId(condition:{deletedAt:null,isPrimary:false}){
      nodes{
        sjId
        tsId
        isPrimary
        deletedAt
        subjectBySjId {
          sjName
          sjOriginalName
        }
      }
      }
    userByUId {
      uUserName
      uUserPassword
      uId
    }
  }
}
`
//To delete teacher

export const DELETE_TEACHER = gql`
mutation deleteTeacher($input:DeleteTeacher!) {
  deleteTeacherById(input: $input) {
    message
  }
}
`;

export const READ_NOTIFICATIONS = gql`
mutation insertUserFeed($fId: UUID!, $uId: UUID!) {
  createUserFeed(input: {userFeed: {uId: $uId, fId: $fId}}) {
    clientMutationId
  }
}`;
